import { render, staticRenderFns } from "./StrategyProjectLocked.vue?vue&type=template&id=79b1bfa3&scoped=true"
import script from "./StrategyProjectLocked.vue?vue&type=script&lang=js"
export * from "./StrategyProjectLocked.vue?vue&type=script&lang=js"
import style0 from "./StrategyProjectLocked.vue?vue&type=style&index=0&id=79b1bfa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b1bfa3",
  null
  
)

export default component.exports